'use client';
import Typography from '@/components/shared/typography/typography.component';
import { colors } from '@/constants';

const FilterTabItem = ({
    text,
    selected,
    tabClicked,
    count,
    id,
}: {
    text: string;
    selected: boolean;
    tabClicked: (id: string | number) => void;
    count: number;
    id: string | number;
}) => {
    return (
        <button
            onClick={() => tabClicked(id)}
            className={`flex items-center justify-between ps-4 pe-[18px] py-2 w-full rounded-md rounded-s-none transition-all ${
                selected ? 'bg-primary-50' : ''
            }`}
            style={
                selected
                    ? {
                          borderInlineStart: `4px solid ${colors['primary-600']}`,
                      }
                    : {}
            }
        >
            <Typography
                className={`${selected ? 'text-primary-700' : 'text-gray-700'}`}
                variant={`${selected ? 'captionSemiBold' : 'captionMedium'}`}
            >
                {text}
            </Typography>
            {count > 0 && (
                <div
                    className={`font-medium text-xs leading-5 text-gray-500 ${
                        selected
                            ? 'text-green-700 px-2 py-0.5 flex items-center justify-center bg-primary-50 rounded-full w-6'
                            : ''
                    }`}
                >
                    {count}
                </div>
            )}
        </button>
    );
};

export default FilterTabItem;
